<template id="vue-stepper">
  <div class="col-12">
    <div class="flex-container container">
      <div class="progress" :style="pBarSize">
        <div class="progress-bar"
             role="progressbar"
             aria-valuenow="60"
             aria-valuemin="0"
             aria-valuemax="100"
             :style="progress">
        </div>
      </div>
      <div class="step"
           v-for="(step, i) in modifiedSteps"
           :key="i"
           :class="{ done: step.onStep < currentStep, current: step.onStep === currentStep }">
        <div class="step-number ml-5" :id="'step-' + step.onStep" v-on:click="moveStep(step.onStep)"></div>
        <div class="step-label">{{step.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "ProgressBar",
  watch:{
    currentTab(){
      let onCurrentTab = this.steps.find(step => step.label === this.currentTab)
      this.currentStep = onCurrentTab.onStep;
    }
  },
  computed: {
    ...mapGetters(["currentTab"]),
    progress() {
      if (this.currentStep > this.steps.length) {
        return `width: 100%`;
      }
      const first = document.getElementById('step-1');
      const current = document.getElementById(`step-${this.currentStep}`);
      if (first && current) {
        const delta = current.getBoundingClientRect().right -first.getBoundingClientRect().right;
        return `width: ${delta}px;`;
      }
      return ""
    },
    modifiedSteps() {
      return this.value.map((step) => {
        if (step.label === 'SupplierInformation') {
          step.name = this.technologyIsFromReseller ? 'Supplier & Reseller information' : 'Supplier Information';
        }
        return step;
      });
    },
  },
  mounted() {
    if (!this.value || this.value.length === 0) {
      return;
    }

    this.steps = this.value.map((s) => ({selected: false, ...s}) );

    this.steps[0].selected = true;

    this.$nextTick(() => {
      this.calculateBarPosition();
    });

    window.addEventListener('resize', this.calculateBarPosition);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateBarPosition);
  },
  data(){
    return{
      pBarSize: '',
      currentStep: 1,
      steps: [
        { label: 'GeneralInformation' , name: "General information", component: "GeneralInformation" , onStep: 1},
        { label: 'SupplierInformation' , name: "Supplier information", component: "SupplierInformation" ,onStep: 2},
        { label: 'AdditionalDetails' ,name: "Data and security", component: "AdditionalDetails",onStep: 3},
        { label: 'PreviewDetails' ,name: "Preview details", component: "PreviewDetails" , onStep: 4}
      ],
    }
  },
  props: { value: Array ,currentComponent : String, technologyIsFromReseller: Boolean},
  methods:{
    ...mapMutations(["setCurrentTab"]),
    moveStep(stepNumber) {
      if(stepNumber < this.currentStep){
        let tabToView = this.steps.find(tab=>tab.onStep === stepNumber).component
        this.setCurrentTab(tabToView);
        this.currentStep = stepNumber;
      }

    },
    calculateBarPosition() {
      this.pBarSize = `left: ${150}px; right: ${120}px; top: ${35}px`;
    }
  }
}
</script>

<style scoped>
.flex-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1em;
}

.progress {
    position: absolute;
    top: 2em;
    height: 5px;
    margin: 0;
    box-shadow: none;
    background-color: #D9D9D9;
}

.step-number {
  background-color: #D9D9D9;
  width:40px;
  height:40px;
  padding: 0.3em;
  color: white;
  border-radius: 2em;
  background-size: 0% 0%;
  background-position: center;
  background-image: radial-gradient(circle at center , var(--secondary-color) 50%, transparent 50%);
  background-repeat: no-repeat;
}

.current {
  .step-number {
    background-image: radial-gradient(circle at center , #fff 50%, transparent 50%);
    border:1px solid var(--secondary-color);
    background-size: 200% 200%;
    transition: all .4s .5s;
  }
}

.done {
  .step-number { background-color: var(--secondary-color); }
}

.step-label {
  padding-top: 5px;
}

.step {
  text-align: center;
  z-index: 2;
  cursor: pointer;
}
</style>